import React from 'react'
import { get } from 'lodash'
import { ReactTable, vehicleStatsByCompany } from '../../feature-react-table'
import { useSearchVehiclesByBuyerDetailLazyQuery } from '../generated/graphql'
import type { SearchCardDetailProps } from '../types'

const {
    Cells: { Account },
    accessors: { accountName, avgSaleAmount, sold, sumSaleAmount },
} = vehicleStatsByCompany

const desktopColumns = [
    {
        Header: 'Account (Buyer)',
        accessor: accountName,
        Cell: Account,
        width: 55,
    },
    {
        Header: 'Purchases',
        accessor: sold,
        width: 15,
    },
    {
        Header: 'Purchase Amt',
        accessor: sumSaleAmount,
        width: 15,
    },
    {
        Header: 'Avg Purchase',
        accessor: avgSaleAmount,
        width: 15,
    },
]

const mobileColumns = [
    {
        Header: 'Account (Buyer)',
        accessor: accountName,
        Cell: Account,
    },
    {
        Header: 'Purchases',
        accessor: sold,
    },
    {
        Header: 'Purchase Amt',
        accessor: sumSaleAmount,
    },
    {
        Header: 'Avg Purchase',
        accessor: avgSaleAmount,
    },
]

export const SearchByBuyerDetailComponent: React.VFC<SearchCardDetailProps> = ({
    searchString,
    title,
}: SearchCardDetailProps) => {
    return (
        <ReactTable
            shareMetaData={{ shareSubject: 'Buyers' }}
            columns={desktopColumns}
            mobileColumns={mobileColumns}
            countPath="auction.search.accountCount"
            lazyQueryHook={useSearchVehiclesByBuyerDetailLazyQuery}
            listPath="auction.search.vehicleStatsByCompany"
            queryOptions={{ variables: { searchString } }}
            paginated
            title={({ res }): string => title || get(res, 'auction.search.searchStringDisplay', 'Search Results')}
        />
    )
}
